import { ChangeDetectionStrategy, Component } from "@angular/core";
import { RouteBreadcrumbStore } from "../../../stores/route-breadcrumb.store";

@Component({
  selector: "app-route-breadcrumb",
  templateUrl: "./route-breadcrumb.component.html",
  styleUrls: ["./route-breadcrumb.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RouteBreadcrumbComponent {
  breadcrumbs = this.routeBreadcrumbStore.breadcrumbs;

  constructor(private readonly routeBreadcrumbStore: RouteBreadcrumbStore) {}
}
